"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Decimal = undefined;

var _decimal = require("../../../decimal");

var _decimal2 = _interopRequireDefault(_decimal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Decimal = _decimal2.default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9zZWxlY3RvcnMvZm9ybXMvYnV5LW4vdHlwZXMuanMiXSwibmFtZXMiOlsiRGVjaW1hbCJdLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUNBOzs7Ozs7UUFDUUEsTyIsImZpbGUiOiJ0eXBlcy5qcyIsInNvdXJjZXNDb250ZW50IjpbIi8vIEBmbG93XG5pbXBvcnQgRGVjaW1hbCBmcm9tIFwiLi4vLi4vLi4vZGVjaW1hbFwiXG5leHBvcnQge0RlY2ltYWx9XG5cbmV4cG9ydCB0eXBlIFBhcnNlZFR5cGUgPSBcImVtcHR5XCIgfCBcImVycm9yXCIgfCBcInZhbFwiIHwgXCIlXCIgfCBcIj1cIiB8IFwiQFwiXG5leHBvcnQgdHlwZSBQYXJzZWQgPSB7XG4gIHRleHQ6ID9zdHJpbmcsXG4gIHR5cGU6IFBhcnNlZFR5cGUsXG4gIHZhbDogRGVjaW1hbCxcbn1cblxuZXhwb3J0IHR5cGUgU3RhdGUgPSB7W3VuaXROYW1lOiBzdHJpbmddOiB7aW5wdXQ6IHN0cmluZ319XG5leHBvcnQgdHlwZSBBY3Rpb24gPSB7XG4gIHR5cGU6IFwiZm9ybS9idXlOXCIsXG4gIHVuaXROYW1lOiBzdHJpbmcsXG4gIGlucHV0OiBzdHJpbmcsXG59XG4iXX0=


//////////////////
// WEBPACK FOOTER
// ../core/lib/selectors/forms/buy-n/types.js
// module id = 230
// module chunks = 0